module.exports = __webpack_public_path__ + "img/close_red.2bc2207c.svg";